import { render, staticRenderFns } from "./ActionTable.vue?vue&type=template&id=5314cdb7&scoped=true&"
import script from "./ActionTable.vue?vue&type=script&lang=js&"
export * from "./ActionTable.vue?vue&type=script&lang=js&"
import style0 from "./ActionTable.vue?vue&type=style&index=0&id=5314cdb7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5314cdb7",
  null
  
)

export default component.exports